import type { SearchOurProperties } from '@tenants/types';

export const searchOurPropertiesConfig: SearchOurProperties = {
  // TODO: When we have listings available, comment back the fields
  // title: {
  //   __html: 'Search Our<br />Properties',
  // },
  // linkText: 'Search Properties',
  // linkPath: '/listings',
  imageCarousel: [
    '/next/assets/images/exp-commercial/ca/commercial-property-example-5.webp',
    '/next/assets/images/exp-commercial/ca/commercial-property-example-6.webp',
    '/next/assets/images/exp-commercial/ca/commercial-property-example-7.webp',
    '/next/assets/images/exp-commercial/ca/commercial-property-example-8.webp',
  ],
};